import apiInstance from '../../../backend-api.setup'
import { ApiPathConfig } from '../../../../config/ApiPathConfig'

export const getReportByIdUsersService = (reportId: string) =>
  apiInstance.get(ApiPathConfig.REPORT_BY_ID_USERS(reportId))
